import { useAct } from 'FlowBuilder/store'
import useGenericTranslate from './useGenericTranslateFlow';
import { AnswerTranslatableKeys } from 'FlowBuilder/lib/questionTranslatable';

export default function useAnswerTranslate<T extends string | number | symbol = AnswerTranslatableKeys>({answerId = null, answerOverride = null, languageOverride = null } = {}) {
  const act = useAct();
  
  const { textContent } = useSel(s => answerOverride || s.answers.entities[answerId] || {})

  const {language, translated, fallback, flag} = useGenericTranslate<T>({ textContent, languageOverride })
  
  function textContentUpdater(key: T, value: string) {
    act.answers.updateAnswerTextContent({answerId, language, key, value})
  }
  
  return {
    language,
    translated,
    fallback,
    textContentUpdater,
    flag
  }
}

